import React from "react"
import { useTranslation } from "react-i18next"

import * as UserApi from "features/api/UserApi"

import { useAlert } from "hooks/useAlert"
import { useSubdomain } from "hooks/useSubdomain"
import { BC_OPERATOR } from "utils/constants"

import FormElement from "components/Form/FormElement"

const defaultFormFields = {
    email: "",
    password: "",
    rememberMail: false
}

const defaultFormEvents = {
    ready: true
}

export const FormNewApp = () => {
    const [formFields, setFormFields] = React.useState(defaultFormFields)
    const [formEvents, setFormEvents] = React.useState(defaultFormEvents)

    const [errors, setErrors] = React.useState([])
    const [showLocalErrors, setShowLocalErrors] = React.useState(false)

    const { alert } = useAlert()
    const { t } = useTranslation()
    const { currentSubdomain } = useSubdomain()

    const handleInputChange = (event) => {
        const target = event.target
        const value = target.type === "checkbox" ? target.checked : target.value
        const name = target.name

        setFormFields({
            ...formFields,
            [name]: value
        })
    }

    const handleValidation = React.useCallback((name, errs) => {
        setErrors((s) => {
            const cleanErrors = [...s.filter((e) => e.origin !== name)]
            return [
                ...cleanErrors,
                ...errs
            ]
        })
    }, [])

    const handleSubmit = async (event) => {
        event.preventDefault()
        // Validate inputs
        const formReady = !(errors.length > 0)

        if (!formReady) {
            setShowLocalErrors(true)
        }
        else {
            // hide error
            setShowLocalErrors(false)
            // prevent form to be submitted again
            setFormEvents({
                ...formEvents,
                ready: false
            })
            try {
              const mail = formFields.email.trim()
              const template_mail = (currentSubdomain.id_api === "OC") ? BC_OPERATOR : currentSubdomain.id_api
              const { getError } = await UserApi.getActivationLink(mail, template_mail)
              if (getError()) throw getError()
              alert("success", t("mail_code_success", { ns: "form" }))

            } catch (error) {
                console.error(error)
                alert("error", error?.message?.toString())
            } finally {
                setFormEvents({
                    ...formEvents,
                    ready: true
                })
            }
        }
    }

    return (
        <form data-cy={"form-activation"}>
            {/* Mail */}
            <FormElement
                value={formFields.email}
                name="email"
                type="email"
                label={t("mail", { ns: "auth" })}
                className="mb-2"
                classNameLabel="text-white"
                required={true}
                placeholder={t("create_account.email_label", { ns: "user" })}
                showErrors={showLocalErrors}
                onValidate={handleValidation}
                onChange={handleInputChange}
            />

            <div className="flex justify-end">
                {formEvents.ready &&
                    <button
                        data-cy={"submit"}
                        type="submit"
                        className="c-btn c-btn--primary-bordered px-12"
                        onClick={handleSubmit}
                    >
                        {t("validate", { ns: "auth" })}
                    </button>
                }
                {!formEvents.ready &&
                    <div data-cy={"spinner"} className="c-spinner mt-5 c-spinner--light"></div>
                }
            </div>
        </form>
    )
}
